import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslationService } from '../../services/translation.service';
import { Locale } from './language.interface';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule
  ],
  template: `
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Change language">
      <mat-icon>language</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="setLanguage(locale.english)" [class.active]="currentLocale === locale.english">
        <span>🇬🇧 English</span>
      </button>
      <button mat-menu-item (click)="setLanguage(locale.polish)" [class.active]="currentLocale === locale.polish">
        <span>🇵🇱 Polski</span>
      </button>
    </mat-menu>
  `,
  styles: [`
    .active {
      font-weight: bold;
    }
  `]
})
export class LanguageSwitcherComponent {
  private translationService = inject(TranslationService);
  public locale: typeof Locale = Locale
  
  currentLocale = this.translationService.getCurrentLanguage();

  setLanguage(locale: Locale) {
    this.translationService.setLanguage(locale);
  }
}
